// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"532":"styles","4736":"vendor"}[chunkId] + "." + {"532":"8dd3dfcc585b769ff573","4736":"550270ce75b457656ee5"}[chunkId] + ".css";
};